function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AreaBox from './AreaBox';
import linkaddress from '@/components/linkaddress';
export default {
  name: 'OperationFloor',
  components: {
    AreaBox: AreaBox,
    linkaddress: linkaddress
  },
  props: {
    /**
     * @description 图片数据对象
     * @type {ImgData}
     */
    imgs: {
      type: Array,
      // 图片
      default: function _default() {
        return '';
      }
    },
    /**
     * @description 是否为热门汤品
     * @type {boolean}
     */
    isHotPot: {
      type: Boolean,
      // 布尔类型
      default: function _default() {
        return false;
      } // 默认值为false
    },
    /**
     * @description 图片区域数据对象
     * @type {AreaData[]}
     */
    imgAreaData: {
      type: Array,
      // 数组类型
      default: function _default() {
        return [];
      } // 默认值为空数组
    },
    /**
     * @description 链接输入框样式对象
     * @type {LinkInputStyle}
     */
    linkInputStyle: {
      type: Object,
      // 对象类型
      default: function _default() {
        return {
          // 默认值为一个包含width属性的对象
          width: '250px',
          height: '32px',
          borderRadius: '4px'
        };
      }
    }
  },
  data: function data() {
    return {
      /**
       * @description 对话框是否可见
       * @type {boolean}
       */
      dialogVisible: false,
      /**
       * @description 开始的x坐标
       * @type {number}
       */
      starX: 0,
      /**
       * @description 开始的y坐标
       * @type {number}
       */
      starY: 0,
      /**
       * @description 区域宽度
       * @type {number}
       */
      areaWidth: 0,
      /**
       * @description 区域高度
       * @type {number}
       */
      areaHeight: 0,
      /**
       * @description 当前显示的图片索引
       * @type {boolean}
       */
      caseShow: false,
      /**
       * @description 当前图片的宽度
       * @type {null}
       */
      nowImgWidth: null,
      /**
       * @description 区域数据
       * @type {Array}
       */
      areaData: [],
      /**
       * @description 当前显示的图片编号
       * @type {number}
       */
      imgNum: 1,
      /**
       * @description 父元素宽度
       * @type {number}
       */
      parentWidth: 0,
      /**
       * @description 父元素高度
       * @type {number}
       */
      parentHeight: 0,
      /**
       * @description 默认宽度
       * @type {number}
       */
      defaultWidth: 456,
      /**
       * @description 当前显示的图片索引
       * @type {number}
       */
      itemIndex: 0,
      nowNum: 0
    };
  },
  computed: {},
  watch: {
    imgAreaData: function imgAreaData(val) {
      this.areaData = _toConsumableArray(val);
    }
  },
  mounted: function mounted() {
    this.areaData = _toConsumableArray(this.imgAreaData);
    this.openModal();
  },
  methods: {
    //添加热区
    addAreaBox: function addAreaBox() {
      if (this.areaData.length === 50) return;
      this.nowNum++;
      var starX = (this.nowNum - 1) % 4 * 114;
      var starY = Math.floor((this.nowNum - 1) / 4) * 114;
      if (starY > this.parentHeight - 114) {
        starY = this.parentHeight - 114;
      }
      this.areaData.push({
        starX: starX,
        starY: starY,
        name: "\u70ED\u533A".concat(this.nowNum),
        areaWidth: 114,
        areaHeight: 114,
        nowImgWidth: 456,
        link: ''
      });
    },
    //重置热区
    resetAreaBox: function resetAreaBox() {
      this.nowNum = 0;
      this.areaData = [];
    },
    btnDialog: function btnDialog(type) {
      var _this = this;
      if (type === 0) {
        this.$modalSure('关闭？').then(function (_) {
          _this.$emit('dialogChange', type, _this.areaData);
          _this.imgAreaData.length == 0 && (_this.nowNum = 0);
          done();
        }).catch(function (_) {});
      } else {
        this.$emit('dialogChange', type, this.areaData);
      }
    },
    openModal: function openModal() {
      var _this2 = this;
      // this.$nextTick(() => {});
      setTimeout(function () {
        var parentDiv = document.querySelector('#img-box-container');
        //获取元素的宽高
        _this2.parentWidth = _this2.defaultWidth;
        // this.parentWidth = parentDiv.clientWidth;
        _this2.parentHeight = parentDiv.clientHeight || 450;
      }, 500);
    },
    closeModal: function closeModal() {
      var _this3 = this;
      this.$Modal.confirm({
        title: '提示信息',
        content: '<p>未保存内容，是否在离开前放弃保存？</p>',
        okText: '确认',
        cancelText: '取消',
        onOk: function onOk() {
          _this3.$Modal.remove();
          _this3.dialogVisible = false;
        }
      });
    },
    // 绘画热区开始
    mouseDown: function mouseDown(e) {
      var _this4 = this;
      e.preventDefault();
      this.caseShow = true;
      // 记录滑动的初始值
      this.starX = e.layerX;
      this.starY = e.layerY;
      // 鼠标滑动的过程
      if (!document.onmousemove) {
        var maxWidth = this.defaultWidth - e.layerX;
        document.onmousemove = function (ev) {
          if (ev.layerX - _this4.starX < maxWidth) {
            _this4.areaWidth = ev.layerX - _this4.starX;
          } else {
            _this4.areaWidth = maxWidth;
          }
          _this4.areaHeight = ev.layerY - _this4.starY;
        };
      }
    },
    // 绘画热区结束
    changeStop: function changeStop() {
      document.onmousemove = null;
      this.imgNum = this.areaData.length + 1;
      if (this.caseShow && this.areaWidth > 10 && this.areaHeight > 10) {
        var data = {
          name: "\u70ED\u533A".concat(this.imgNum),
          starX: this.starX,
          starY: this.starY,
          areaWidth: this.areaWidth < 50 ? 50 : this.areaWidth,
          areaHeight: this.areaHeight < 50 ? 50 : this.areaHeight,
          nowImgWidth: this.defaultWidth,
          link: ''
        };
        this.areaData.push(data);
      }
      // 初始化绘图
      this.caseShow = false;
      this.starX = 0;
      this.starY = 0;
      this.areaWidth = 0;
      this.areaHeight = 0;
    },
    // 删除指定热区
    delAreaBox: function delAreaBox(index) {
      /* 删除某个热区 */
      this.areaData.splice(index, 1);
      // this.$emit('delAreaData', this.areaData);
      /* 删除后 每个热区按顺序重新编号 */
      if (this.areaData) {
        var arr = this.areaData.filter(function (i) {
          return i.number > index;
        });
        if (!arr) return;
        arr.forEach(function (i) {
          return i.number--;
        });
        if (this.areaData[this.areaData.length - 1]) {
          this.imgNum = this.areaData[this.areaData.length - 1].number + 1;
        } else {
          this.imgNum = 1;
        }
      }
    },
    // 添加网址
    addURL: function addURL(index, url) {
      var obj = _objectSpread(_objectSpread({}, this.areaData[index]), {}, {
        link: url
      });
      this.$set(this.areaData, index, obj);
    },
    /**
     * 检查列表中每个元素是否都有 link 属性
     * @param {Array} list - 待检查的列表
     * @returns {Boolean} - 是否所有元素都有 link 属性
     */
    checkData: function checkData(list) {
      var isCheck = true;
      list.some(function (val) {
        if (!val.link) {
          isCheck = false;
        }
      });
      return isCheck;
    },
    /**
     * @description 获取链接地址并打开添加链接的模态框
     * @param {number} index - 当前项的索引值
     */
    getLink: function getLink(index) {
      // 设置当前项的索引值
      this.itemIndex = index;
      // 打开添加链接的模态框
      // this.$refs.linkaddres.currenType = 'link';
      // this.$refs.linkaddres.mockData('link');
      this.$refs.linkaddres.dialogVisible = true;
    },
    /**
     * @description 处理链接地址的输入事件
     * @param {string} e - 链接地址
     */
    linkUrl: function linkUrl(e) {
      // 将链接地址存储到对应的数据项中
      this.areaData[this.itemIndex].link = e;
    }
  }
};